import Image from '@tiptap/extension-image'
import { VueNodeViewRenderer } from '@tiptap/vue-2'
import ImageResizableTemplate from './ImageResizableTemplate.vue'

const ImageResizable = Image.extend({
  name: 'ImageResizable',

  addAttributes() {
    // return an object with attribute configuration

    return {
      ...this.parent?.(),

      src: {
        default: '',

        renderHTML: (attributes) => {
          // … and return an object with HTML attributes
          return {
            src: attributes.src,
          }
        },
      },

      width: {
        default: 750,
        renderHTML: ({ width }) => ({ width }),
      },

      height: {
        default: 500,
        renderHTML: ({ height }) => ({ height }),
      },

      isDraggable: {
        default: true,
        // we don't want it to render on the img tag
        renderHTML: () => {
          return {}
        },
      },

      link: {
        default: null,

        parseHTML: (element) => {
          // ignore everything except images with a `link` attribute
          return element.getAttribute('link') || null
        },

        renderHTML: (attributes) => {
          // map (non-null) link attributes to href and target
          return {
            href: attributes.link,
            target: attributes.link ? '_blank' : null,
          }
        },
      },
    }
  },

  addNodeView() {
    return VueNodeViewRenderer(ImageResizableTemplate)
  },

  renderHTML(attr) {
    // if we have `href` set, wrap the `img` tag in an `a` tag,
    // each tag with appropriate attributes:
    // `link` for `img` - for the next time we parse (edit post);
    // `href` for the `a` tag itself
    if (attr.HTMLAttributes.href) {
      return [
        'a',
        { href: attr.HTMLAttributes.href, target: attr.HTMLAttributes.target },
        [
          'img',
          {
            src: attr.HTMLAttributes.src,
            width: attr.HTMLAttributes.width,
            height: attr.HTMLAttributes.height,
            link: attr.HTMLAttributes.href,
          },
        ],
      ]
    }

    // otherwise just render the image
    return ['img', attr.HTMLAttributes]
  },
})

export { ImageResizable }
export default ImageResizable
